(function () {
  'use strict';

  var doc = document;

  function qs(sel, root) {
    return (root || doc).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || doc).querySelectorAll(sel));
  }

  function toggleClass(el, name, on) {
    if (!el) return;
    el.classList.toggle(name, on);
  }

  function lockScroll(lock) {
    doc.body.style.overflow = lock ? 'hidden' : '';
  }

  var lastFocus = null;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function isVisible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function getOpenLayer() {
    return qs(
      '.cart-drawer.is-open, .search-modal.is-open, .mobile-drawer.is-open, [data-quick-view-modal].is-open, [data-pdp-zoom]:not([hidden]), [data-size-chart]:not([hidden])'
    );
  }

  function focusables(root) {
    return qsa(FOCUSABLE, root).filter(isVisible);
  }

  function trapFocus(e) {
    if (e.key !== 'Tab') return;
    var layer = getOpenLayer();
    if (!layer) return;
    var nodes = focusables(layer);
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (e.shiftKey && doc.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && doc.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function restoreFocus() {
    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
    lastFocus = null;
  }

  function openDrawer(id) {
    var drawer = qs(id);
    var backdrop = qs('[data-drawer-backdrop]');
    if (!drawer) return;
    lastFocus = doc.activeElement;
    if (lastFocus && lastFocus.getAttribute) {
      lastFocus.setAttribute('aria-expanded', 'true');
    }
    drawer.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-open');
    lockScroll(true);
    drawer.setAttribute('aria-hidden', 'false');
    var main = qs('#MainContent');
    var footer = qs('.shopify-section-group-footer-group, footer.site-footer');
    if (main) main.setAttribute('inert', '');
    if (footer) footer.setAttribute('inert', '');
    if (id === '#SearchModal') {
      var input = qs('[data-search-input]', drawer);
      if (input) {
        setTimeout(function () {
          input.focus();
        }, 80);
      }
      return;
    }
    var closeBtn = qs('[data-close-drawers]', drawer);
    if (closeBtn) {
      setTimeout(function () {
        closeBtn.focus();
      }, 80);
    }
  }

  function closeDrawers() {
    qsa('.mobile-drawer, .cart-drawer, .search-modal').forEach(function (el) {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
    });
    var backdrop = qs('[data-drawer-backdrop]');
    if (backdrop) backdrop.classList.remove('is-open');
    qsa('[data-open][aria-expanded="true"]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
    var main = qs('#MainContent');
    var footer = qs('.shopify-section-group-footer-group, footer.site-footer');
    if (main) main.removeAttribute('inert');
    if (footer) footer.removeAttribute('inert');
    lockScroll(false);
    restoreFocus();
  }

  doc.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-open]');
    if (openBtn) {
      e.preventDefault();
      openDrawer(openBtn.getAttribute('data-open'));
      return;
    }
    if (e.target.closest('[data-close-drawers], [data-drawer-backdrop]')) {
      e.preventDefault();
      closeDrawers();
    }
  });

  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') trapFocus(e);
    var zoom = qs('[data-pdp-zoom]:not([hidden])');
    if (zoom) {
      var gallery = qs('[data-pdp-gallery]');
      if (e.key === 'Escape') {
        zoom.setAttribute('hidden', '');
        doc.body.classList.remove('mpv1-zoom-open');
        var hit = qs('[data-pdp-zoom-open]');
        if (hit) hit.focus();
        return;
      }
      if ((e.key === 'ArrowLeft' || e.key === 'ArrowRight') && gallery && gallery._pdpActivate) {
        gallery._pdpActivate(e.key === 'ArrowLeft' ? -1 : 1, true);
        return;
      }
    }
    var sizeChart = qs('[data-size-chart]:not([hidden])');
    if (sizeChart && e.key === 'Escape') {
      sizeChart.setAttribute('hidden', '');
      doc.body.classList.remove('mpv1-size-chart-open');
      var openBtn = qs('[data-size-chart-open]');
      if (openBtn) openBtn.focus();
      return;
    }
    if (e.key === 'Escape') {
      if (qs('[data-quick-view-modal].is-open')) {
        doc.dispatchEvent(new CustomEvent('kneevive:close-quick-view'));
        return;
      }
      closeDrawers();
    }
  });

  /* Homepage transparent header — white until scroll */
  (function bindHeaderScroll() {
    var header = qs('[data-header]');
    if (!header) return;
    function onScroll() {
      var scrolled = window.scrollY > 24;
      header.classList.toggle('has-scrolled', scrolled);
      doc.body.classList.toggle('has-scrolled', scrolled);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  /* Influencer carousel — 4-up like live Flickity */
  qsa('[data-review-carousel]').forEach(function (wrap) {
    var track = qs('[data-review-track]', wrap);
    var prev = qs('[data-review-prev]', wrap);
    var next = qs('[data-review-next]', wrap);
    if (!track) return;
    function step() {
      var card = qs('.review-card', track);
      return card ? card.getBoundingClientRect().width + 20 : track.clientWidth * 0.25;
    }
    function go(dir) {
      track.scrollBy({ left: dir * step(), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
  });

  /* Product singles / bundles toggle */
  qsa('[data-product-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('[data-product-toggle-group]');
      if (!group) return;
      qsa('[data-product-toggle]', group).forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
        b.classList.toggle('active', b === btn);
      });
      var target = btn.getAttribute('data-product-toggle');
      qsa('[data-product-panel]', group).forEach(function (panel) {
        var show = panel.getAttribute('data-product-panel') === target;
        panel.classList.toggle('hidden', !show);
      });
    });
  });

  /* KNEEVIVE tabs + product carousel */
  qsa('[data-up-tabs]').forEach(function (wrap) {
    qsa('[data-up-tab]', wrap).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-up-tab');
        qsa('[data-up-tab]', wrap).forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        qsa('[data-up-panel]', wrap).forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-up-panel') === id);
        });
      });
    });
  });

  doc.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-pc-prev]');
    var nextBtn = e.target.closest('[data-pc-next]');
    if (!prev && !nextBtn) return;
    var root = (prev || nextBtn).closest('.pc');
    var track = root && qs('[data-pc-track]', root);
    if (!track) return;
    e.preventDefault();
    track.scrollBy({
      left: (nextBtn ? 1 : -1) * (track.clientWidth * 0.8),
      behavior: 'smooth',
    });
  });
  function setFaqOpen(item, open) {
    item.classList.toggle('is-open', open);
    var btn = qs('button', item);
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  doc.addEventListener('click', function (e) {
    var faqBtn = e.target.closest('[data-faq-item] button');
    if (!faqBtn) return;
    var item = faqBtn.closest('[data-faq-item]');
    if (!item) return;
    var willOpen = !item.classList.contains('is-open');
    var group = item.parentElement;
    if (group) {
      qsa('[data-faq-item]', group).forEach(function (other) {
        setFaqOpen(other, false);
      });
    }
    if (willOpen) setFaqOpen(item, true);
  });

  /* Ingredient tabs */
  qsa('[data-ing-tabs]').forEach(function (wrap) {
    qsa('[data-ing-tab]', wrap).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-ing-tab');
        qsa('[data-ing-tab]', wrap).forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        qsa('[data-ing-panel]', wrap).forEach(function (panel) {
          panel.classList.toggle('hidden', panel.getAttribute('data-ing-panel') !== id);
        });
      });
    });
  });

  qsa('[data-how-tabs]').forEach(function (wrap) {
    qsa('[data-how-tab]', wrap).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-how-tab');
        qsa('[data-how-tab]', wrap).forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        qsa('[data-how-panel]', wrap).forEach(function (panel) {
          panel.classList.toggle('hidden', panel.getAttribute('data-how-panel') !== id);
        });
      });
    });
  });

  /* PDP gallery (main image swap + zoom) */
  function initPdpGalleries(scope) {
    qsa('[data-pdp-gallery]', scope || doc).forEach(function (gallery) {
      if (gallery.getAttribute('data-pdp-bound') === 'true') return;
      gallery.setAttribute('data-pdp-bound', 'true');
      var main = qs('[data-pdp-main-img], .mpv1-gallery__main-img', gallery);
      var thumbs = qsa('[data-pdp-thumb]', gallery);
      var counter = qs('[data-pdp-counter]', gallery);
      var index = 0;
      thumbs.forEach(function (t, n) {
        if (t.classList.contains('is-active')) index = n;
      });

      function setMainImage(url, alt) {
        if (!main || !url) return;
        // Clear srcset/sizes so the browser actually shows the new src
        // (otherwise responsive srcset keeps the previous image).
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = url;
        if (alt) main.alt = alt;
      }

      function scrollThumbIntoView(thumb) {
        var rail = qs('.mpv1-gallery__thumbs', gallery);
        if (!rail || !thumb) return;
        var railRect = rail.getBoundingClientRect();
        var thumbRect = thumb.getBoundingClientRect();
        var delta =
          thumbRect.left -
          railRect.left -
          (railRect.width - thumbRect.width) / 2;
        rail.scrollBy({ left: delta, behavior: 'smooth' });
      }

      function activate(i, relative) {
        if (!thumbs.length) return;
        if (relative) i = index + i;
        index = ((i % thumbs.length) + thumbs.length) % thumbs.length;
        var thumb = thumbs[index];
        thumbs.forEach(function (t, n) {
          t.classList.toggle('is-active', n === index);
        });
        scrollThumbIntoView(thumb);
        if (main && thumb) {
          var full = thumb.getAttribute('data-full');
          var img = qs('img', thumb);
          var nextSrc = full || (img && (img.currentSrc || img.src));
          setMainImage(nextSrc, img && img.alt);
        }
        if (counter) counter.textContent = index + 1 + ' / ' + thumbs.length;
        var zoomEl = qs('[data-pdp-zoom]');
        var zoomImg = qs('[data-pdp-zoom-img]');
        if (zoomImg && main && zoomEl && !zoomEl.hasAttribute('hidden')) {
          zoomImg.src = main.src;
        }
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          activate(i);
        });
      });

      var prev = qs('[data-pdp-prev]', gallery);
      var next = qs('[data-pdp-next]', gallery);
      if (prev) prev.addEventListener('click', function () { activate(-1, true); });
      if (next) next.addEventListener('click', function () { activate(1, true); });

      var zoom = qs('[data-pdp-zoom]');
      var zoomImg = zoom && qs('[data-pdp-zoom-img]', zoom);
      function openZoom() {
        if (!zoom || !main) return;
        if (zoomImg) {
          zoomImg.src = main.src;
          zoomImg.alt = main.alt || '';
        }
        zoom.removeAttribute('hidden');
        doc.body.classList.add('mpv1-zoom-open');
        var closeBtn = qs('[data-pdp-zoom-close]', zoom);
        if (closeBtn) closeBtn.focus();
      }
      function closeZoom() {
        if (!zoom) return;
        zoom.setAttribute('hidden', '');
        doc.body.classList.remove('mpv1-zoom-open');
      }
      var zoomOpen = qs('[data-pdp-zoom-open]', gallery);
      if (zoomOpen) zoomOpen.addEventListener('click', openZoom);
      if (zoom && zoom.getAttribute('data-zoom-bound') !== 'true') {
        zoom.setAttribute('data-zoom-bound', 'true');
        var zoomClose = qs('[data-pdp-zoom-close]', zoom);
        var zoomPrev = qs('[data-pdp-zoom-prev]', zoom);
        var zoomNext = qs('[data-pdp-zoom-next]', zoom);
        if (zoomClose) zoomClose.addEventListener('click', closeZoom);
        zoom.addEventListener('click', function (e) {
          if (e.target === zoom) closeZoom();
        });
        if (zoomPrev) zoomPrev.addEventListener('click', function (e) {
          e.stopPropagation();
          activate(-1, true);
        });
        if (zoomNext) zoomNext.addEventListener('click', function (e) {
          e.stopPropagation();
          activate(1, true);
        });
      }

      gallery._pdpActivate = activate;
    });
  }
  initPdpGalleries();

  function initPdpAccordions(scope) {
    qsa('[data-mpv1-accordion]', scope || doc).forEach(function (acc) {
      if (acc.getAttribute('data-pdp-bound') === 'true') return;
      acc.setAttribute('data-pdp-bound', 'true');
      var btn = qs('.mpv1-accordion__trigger', acc);
      var panel = qs('.mpv1-accordion__panel', acc);
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var open = acc.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.style.height = open ? panel.scrollHeight + 'px' : '0px';
      });
    });
  }
  initPdpAccordions();

  /* Quantity (PDP) */
  doc.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-qty]');
    if (!qtyBtn || qtyBtn.hasAttribute('data-cart-qty-change')) return;
    var wrap = qtyBtn.closest('.qty');
    var input = wrap && qs('input', wrap);
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    if (qtyBtn.getAttribute('data-qty') === 'inc') val = Math.min(99, val + 1);
    else val = Math.max(1, val - 1);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    if (input.closest('#ProductForm')) syncPdpTotals();
  });

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var number = Math.abs(parseInt(cents, 10) || 0);
    var formatString = format || window.themeMoneyFormat || '{{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(num, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      var parts = (num / 100).toFixed(precision).split('.');
      var major = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var minor = parts[1] ? decimal + parts[1] : '';
      return major + minor;
    }

    var token = (formatString.match(placeholder) || [])[1] || 'amount';
    var value;
    switch (token) {
      case 'amount_no_decimals':
        value = withDelimiters(number, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(number, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(number, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = withDelimiters(number, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(number, 2, "'", '.');
        break;
      case 'amount_with_space_separator':
        value = withDelimiters(number, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = withDelimiters(number, 2, ' ', '.');
        break;
      default:
        value = withDelimiters(number, 2);
    }
    return formatString.replace(placeholder, value);
  }

  function parsePlanMap(form) {
    var node = form && qs('[data-variant-plans]', form);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (err) {
      return null;
    }
  }

  function isSubscribeSelected(form) {
    if (!form) return false;
    var checked = qs('[name="purchase_option"]:checked', form);
    if (checked) return checked.value === 'subscribe';
    return false;
  }

  function getPdpUnitPrice(form) {
    var oneTime = parseInt(form.getAttribute('data-unit-price'), 10) || 0;
    if (!isSubscribeSelected(form)) return oneTime;
    var map = parsePlanMap(form);
    if (!map) return oneTime;
    var idInput = qs('[name="id"]', form);
    var data = map[String(idInput && idInput.value)];
    var select = qs('[data-selling-plan-select]', form);
    var planId = select && select.value;
    if (data && planId && data.plans && data.plans[planId] && data.plans[planId].price != null) {
      return parseInt(data.plans[planId].price, 10) || oneTime;
    }
    return oneTime;
  }

  function setAtcLabel(atc, available, isSub) {
    if (!atc) return;
    var label = qs('[data-pdp-atc-label]', atc);
    var text;
    if (!available) text = atc.getAttribute('data-label-sold') || 'Sold out';
    else if (isSub) text = atc.getAttribute('data-label-subscribe') || 'Subscribe now';
    else text = atc.getAttribute('data-label-onetime') || 'Add to cart';
    if (label) label.textContent = text;
    else if (!qs('[data-pdp-atc-price]', atc)) atc.textContent = text;
  }

  function syncStickyAtc(available) {
    var form = qs('#ProductForm');
    var atc = qs('[data-pdp-atc]');
    var stickyBtn = qs('[data-pdp-sticky-atc]');
    var canBuy = available;
    if (canBuy === undefined) canBuy = !(atc && atc.disabled);
    var isSub = isSubscribeSelected(form);
    if (atc) {
      atc.disabled = !canBuy;
      setAtcLabel(atc, canBuy, isSub);
    }
    if (!stickyBtn) return;
    stickyBtn.disabled = !canBuy;
    setAtcLabel(stickyBtn, canBuy, isSub);
  }

  function getPackTierConfig(form) {
    return {
      pct2: Math.max(0, Math.min(90, parseInt(form.getAttribute('data-pack-2-percent'), 10) || 0)),
      pct3: Math.max(0, Math.min(90, parseInt(form.getAttribute('data-pack-3-percent'), 10) || 0))
    };
  }

  function packOfferTotal(unit, qty, form) {
    var cfg = getPackTierConfig(form);
    var n = Math.max(1, parseInt(qty, 10) || 1);
    if (n === 2 && cfg.pct2 > 0) return Math.round((unit * 2 * (100 - cfg.pct2)) / 100);
    if (n === 3 && cfg.pct3 > 0) return Math.round((unit * 3 * (100 - cfg.pct3)) / 100);
    return unit * n;
  }

  function packOfferCompare(retail, unit, qty, form) {
    var n = Math.max(1, parseInt(qty, 10) || 1);
    var base = retail > unit ? retail : unit;
    var compare = base * n;
    var total = packOfferTotal(unit, n, form);
    return compare > total ? compare : 0;
  }

  function syncPdpTotals() {
    var form = qs('#ProductForm');
    if (!form) return;
    var unit = getPdpUnitPrice(form);
    var retail = parseInt(form.getAttribute('data-compare-price'), 10) || 0;
    var qtyInput = qs('[name="quantity"]', form);
    var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    if (qtyInput) qtyInput.value = qty;
    var total = packOfferTotal(unit, qty, form);
    qsa('[data-pack-price]').forEach(function (el) {
      var n = parseInt(el.getAttribute('data-pack-price'), 10) || 1;
      el.textContent = formatMoney(packOfferTotal(unit, n, form));
    });
    qsa('[data-pack-total]').forEach(function (el) {
      var n = parseInt(el.getAttribute('data-pack-total'), 10) || 1;
      el.textContent = formatMoney(packOfferTotal(unit, n, form));
    });
    qsa('[data-pack-compare]').forEach(function (el) {
      var n = parseInt(el.getAttribute('data-pack-compare'), 10) || 1;
      var compare = packOfferCompare(retail, unit, n, form);
      var wrap = el.closest('.mpv1-switcher__compare-price');
      if (compare) {
        el.textContent = formatMoney(compare);
        if (wrap) wrap.style.display = '';
      } else if (wrap) {
        wrap.style.display = 'none';
      }
    });
    qsa('[data-pdp-pack]').forEach(function (btn) {
      btn.classList.toggle('is-selected', parseInt(btn.getAttribute('data-pdp-pack'), 10) === qty);
    });
    var priceEl = qs('[data-pdp-price]');
    if (priceEl) priceEl.textContent = formatMoney(unit);
    var atcPrice = qs('[data-pdp-atc-price]');
    if (atcPrice) atcPrice.textContent = formatMoney(total);
    var sticky = qs('[data-pdp-sticky-price]');
    if (sticky) sticky.textContent = formatMoney(total);
    var stickyLabel = qs('[data-pdp-sticky-price-label]');
    if (stickyLabel) stickyLabel.textContent = formatMoney(total);
    var atc = qs('[data-pdp-atc]');
    syncStickyAtc(!(atc && atc.disabled));
  }

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('hidden', !count);
    });
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function lineHtml(item) {
    var compare = item.original_line_price;
    var discounts = (item.discounts || [])
      .map(function (d) {
        return '<p>' + escapeHtml(d.title) + '</p>';
      })
      .join('');
    var plan =
      item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
        ? '<p>' + escapeHtml(item.selling_plan_allocation.selling_plan.name) + '</p>'
        : '';
    var variant =
      item.variant_title && item.variant_title !== 'Default Title'
        ? '<p>' + escapeHtml(item.variant_title) + '</p>'
        : '';
    var compareHtml =
      compare > item.final_line_price ? '<s>' + formatMoney(compare) + '</s>' : '';
    return (
      '<div class="cart-line" data-line-key="' +
      escapeHtml(item.key) +
      '">' +
      '<a class="cart-line__media" href="' +
      escapeHtml(item.url) +
      '"><img src="' +
      escapeHtml(item.image || '') +
      '" alt="" width="72" height="72"></a>' +
      '<div class="cart-line__info"><div class="cart-line__top"><a href="' +
      escapeHtml(item.url) +
      '"><strong>' +
      escapeHtml(String(item.product_title || '').length > 48
        ? String(item.product_title).slice(0, 45) + '…'
        : item.product_title) +
      '</strong></a>' +
      '<button class="cart-line__remove" type="button" data-cart-remove="' +
      escapeHtml(item.key) +
      '" aria-label="Remove ' +
      escapeHtml(item.product_title) +
      '">×</button></div>' +
      variant +
      discounts +
      plan +
      '<div class="cart-line__bottom"><div class="qty" data-cart-qty>' +
      '<button type="button" data-qty="dec" data-cart-qty-change="' +
      escapeHtml(item.key) +
      '" aria-label="Decrease quantity">−</button>' +
      '<input type="number" value="' +
      item.quantity +
      '" min="1" data-cart-qty-input="' +
      escapeHtml(item.key) +
      '" aria-label="Quantity">' +
      '<button type="button" data-qty="inc" data-cart-qty-change="' +
      escapeHtml(item.key) +
      '" aria-label="Increase quantity">+</button></div>' +
      '<p class="cart-line__price"><span>' +
      formatMoney(item.final_line_price) +
      '</span>' +
      compareHtml +
      '</p></div></div></div>'
    );
  }

  function fillAmount(tpl, cents) {
    return String(tpl || '').replace(/\[amount\]/g, formatMoney(cents));
  }

  function updateProgress(cart) {
    var root = qs('[data-cart-root]');
    if (!root) return;
    var shipAt = parseInt(root.getAttribute('data-ship-at'), 10) || 6000;
    var total = cart.total_price || 0;
    var fill = qs('[data-progress-fill]', root);
    var msg = qs('[data-progress-msg]', root);
    var pct = Math.min(100, shipAt ? (total / shipAt) * 100 : 0);
    if (fill) fill.style.width = pct + '%';
    var goals = qsa('.cart-progress__goal', root);
    if (goals[0]) goals[0].classList.toggle('is-done', total >= shipAt);
    if (!msg) return;
    if (!cart.item_count) {
      msg.textContent = root.getAttribute('data-msg-empty') || 'Add products to unlock Free Shipping.';
    } else if (total >= shipAt) {
      msg.textContent = root.getAttribute('data-msg-ship-unlocked') || 'FREE shipping will be applied at checkout';
    } else {
      msg.textContent = fillAmount(
        root.getAttribute('data-msg-ship-away') || 'Spend [amount] more for FREE shipping.',
        shipAt - total
      );
    }
  }

  function refreshCartDrawer(cart) {
    var root = qs('[data-cart-root]');
    if (!root) return;
    var empty = qs('[data-cart-empty]', root);
    var lines = qs('[data-cart-lines]', root);
    var total = qs('[data-cart-total]', root);
    var subLabel = qs('[data-cart-subtotal-label]', root);
    if (empty) empty.classList.toggle('hidden', cart.item_count > 0);
    if (lines) {
      lines.innerHTML = (cart.items || []).map(lineHtml).join('');
    }
    if (total) total.textContent = formatMoney(cart.total_price);
    if (subLabel) {
      var n = cart.item_count || 0;
      subLabel.textContent = 'Subtotal (' + n + ' ' + (n === 1 ? 'item' : 'items') + ')';
    }
    var pageLines = qs('[data-cart-page-lines]');
    if (pageLines) pageLines.innerHTML = (cart.items || []).map(lineHtml).join('');
    var pageTotal = qs('[data-cart-page-total]');
    if (pageTotal) pageTotal.textContent = formatMoney(cart.total_price);
    if (doc.body.classList.contains('template-cart') && !cart.item_count && pageLines) {
      window.location.reload();
    }
    updateProgress(cart);
    updateCartCount(cart.item_count);
    syncCartUpsells(cart);
  }

  function syncCartUpsells(cart) {
    var root = qs('[data-cart-root]');
    if (!root) return;
    var wrap = qs('[data-cart-upsells]', root);
    if (!wrap) return;
    var inCart = {};
    (cart.items || []).forEach(function (item) {
      if (item.product_id) inCart[String(item.product_id)] = true;
    });
    var visible = 0;
    qsa('[data-cart-upsell]', wrap).forEach(function (card) {
      var id = card.getAttribute('data-upsell-id');
      var hide = !!(id && inCart[id]);
      card.classList.toggle('hidden', hide);
      if (!hide) visible += 1;
    });
    wrap.classList.toggle('hidden', visible === 0);
    var emptyTitle = qs('[data-upsell-title="empty"]', wrap);
    var filledTitle = qs('[data-upsell-title="filled"]', wrap);
    if (emptyTitle) emptyTitle.classList.toggle('hidden', cart.item_count > 0);
    if (filledTitle) filledTitle.classList.toggle('hidden', !cart.item_count);
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) {
      return r.json();
    });
  }

  function changeCart(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    })
      .then(function (r) {
        if (!r.ok) throw r;
        return r.json();
      })
      .then(refreshCartDrawer)
      .catch(function () {
        fetchCart().then(refreshCartDrawer);
      });
  }

  fetchCart().then(refreshCartDrawer).catch(function () {});

  doc.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      changeCart(removeBtn.getAttribute('data-cart-remove'), 0);
      return;
    }
    var qtyBtn = e.target.closest('[data-cart-qty-change]');
    if (!qtyBtn) return;
    e.preventDefault();
    var key = qtyBtn.getAttribute('data-cart-qty-change');
    var input = qs('[data-cart-qty-input="' + key + '"]');
    var val = input ? parseInt(input.value, 10) || 1 : 1;
    if (qtyBtn.getAttribute('data-qty') === 'inc') val += 1;
    else val = Math.max(0, val - 1);
    if (input) input.value = val || 1;
    changeCart(key, val);
  });

  doc.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty-input]');
    if (!input) return;
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    changeCart(input.getAttribute('data-cart-qty-input'), qty);
  });

  /* Ajax add to cart */
  doc.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-add-to-cart]');
    if (!addBtn || addBtn.disabled) return;
    e.preventDefault();
    var form = addBtn.closest('form') || qs('#ProductForm');
    var id = addBtn.getAttribute('data-variant-id');
    var qtyEl = form && qs('[name="quantity"]', form);
    var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
    if (addBtn.hasAttribute('data-qv-atc')) {
      var qvQty = qs('[data-qv-qty]');
      if (qvQty) qty = Math.max(1, parseInt(qvQty.value, 10) || 1);
    }
    if (!id) {
      var selected = form ? qs('[name="id"]', form) : qs('[name="id"]');
      if (selected) id = selected.value;
    }

    var bundleItems = getBundleLineItems(form);
    var payload;
    if (bundleItems && bundleItems.length) {
      if (bundleItems.some(function (item) { return !item.id; })) return;
      payload = { items: bundleItems };
    } else {
      if (!id) return;
      payload = { id: Number(id), quantity: qty };
      var planSelect = form && qs('[data-selling-plan-select]', form);
      var planAttr = addBtn.getAttribute('data-selling-plan');
      var subscribe = form ? qs('[name="purchase_option"]:checked', form) : null;
      if (subscribe && subscribe.value === 'onetime') {
        planSelect = null;
        planAttr = null;
      }
      var planId = planAttr;
      if (planSelect && !planSelect.disabled && planSelect.value) {
        planId = planSelect.value;
      }
      if (planId) payload.selling_plan = Number(planId);
    }

    addBtn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (r) {
        if (!r.ok) throw r;
        return fetchCart();
      })
      .then(function (cart) {
        refreshCartDrawer(cart);
        if (addBtn.hasAttribute('data-qv-atc')) {
          doc.dispatchEvent(new CustomEvent('kneevive:close-quick-view'));
        }
        openDrawer('#CartDrawer');
      })
      .catch(function () {
        if (form && form.getAttribute('action') && !bundleItems) {
          form.submit();
          return;
        }
        window.location.href = '/cart';
      })
      .finally(function () {
        addBtn.classList.remove('is-loading');
      });
  });

  function getPdpVariants(form) {
    var node = form && qs('[data-mpv1-variants]', form);
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]') || [];
    } catch (err) {
      return [];
    }
  }

  function findVariantByOptions(variants, optionValues) {
    return (
      variants.filter(function (v) {
        return optionValues.every(function (val, i) {
          return v.options[i] === val;
        });
      })[0] || null
    );
  }

  function getBundleLineItems(form) {
    if (!form) return null;
    var activeLines = qs('[data-pack-lines]:not([hidden])', form);
    if (!activeLines) return null;
    var variants = getPdpVariants(form);
    if (!variants.length) return null;
    var items = [];
    var ok = true;
    qsa('[data-bundle-line]', activeLines).forEach(function (row) {
      var opts = qsa('select[data-bundle-option-index]', row)
        .sort(function (a, b) {
          return (
            parseInt(a.getAttribute('data-bundle-option-index'), 10) -
            parseInt(b.getAttribute('data-bundle-option-index'), 10)
          );
        })
        .map(function (sel) {
          return sel.value;
        });
      var match = findVariantByOptions(variants, opts);
      qsa('.mpv1-bundle-line__select', row).forEach(function (sel) {
        sel.classList.toggle('is-unavailable', !(match && match.available));
      });
      if (!match || !match.available) {
        ok = false;
        items.push({ id: 0, quantity: 1 });
        return;
      }
      items.push({ id: Number(match.id), quantity: 1 });
    });
    if (!ok) return items;
    return items;
  }

  function syncBundleLinesVisibility(packQty) {
    var form = qs('#ProductForm');
    if (!form) return;
    var n = Math.max(1, parseInt(packQty, 10) || 1);
    qsa('[data-pack-wrap]', form).forEach(function (wrap) {
      var wrapN = parseInt(wrap.getAttribute('data-pack-wrap'), 10) || 1;
      wrap.classList.toggle('is-active-pack', wrapN === n);
    });
    qsa('[data-pack-lines]', form).forEach(function (el) {
      var lineN = parseInt(el.getAttribute('data-pack-lines'), 10) || 0;
      var show = lineN === n && n > 1;
      if (show) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
    seedBundleLinesFromChips(form);
    validateBundleLines(form);
  }

  function seedBundleLinesFromChips(form) {
    var optionsRoot = qs('[data-mpv1-options]', form);
    if (!optionsRoot) return;
    var selected = qsa('.mpv1-options__row', optionsRoot).map(function (row) {
      var active = qs('.mpv1-option-chip.is-active', row);
      return active ? active.getAttribute('data-option-value') : '';
    });
    qsa('[data-pack-lines]:not([hidden]) [data-bundle-line]', form).forEach(function (row) {
      qsa('select[data-bundle-option-index]', row).forEach(function (sel) {
        var idx = parseInt(sel.getAttribute('data-bundle-option-index'), 10) || 0;
        if (selected[idx] && sel.value !== selected[idx]) {
          var has = qsa('option', sel).some(function (opt) {
            return opt.value === selected[idx];
          });
          if (has) sel.value = selected[idx];
        }
      });
    });
  }

  function validateBundleLines(form) {
    var activeLines = form && qs('[data-pack-lines]:not([hidden])', form);
    if (!activeLines) {
      var atc = qs('[data-pdp-atc]');
      if (atc && !atc.hasAttribute('data-force-disabled')) {
        /* leave availability to variant picker */
      }
      return true;
    }
    var variants = getPdpVariants(form);
    var allOk = true;
    qsa('[data-bundle-line]', activeLines).forEach(function (row) {
      var opts = qsa('select[data-bundle-option-index]', row)
        .sort(function (a, b) {
          return (
            parseInt(a.getAttribute('data-bundle-option-index'), 10) -
            parseInt(b.getAttribute('data-bundle-option-index'), 10)
          );
        })
        .map(function (sel) {
          return sel.value;
        });
      var match = findVariantByOptions(variants, opts);
      var available = !!(match && match.available);
      qsa('.mpv1-bundle-line__select', row).forEach(function (sel) {
        sel.classList.toggle('is-unavailable', !available);
      });
      if (!available) allOk = false;
    });
    var atc = qs('[data-pdp-atc]');
    if (atc) atc.disabled = !allOk;
    return allOk;
  }

  function initPdpBundleLines() {
    var form = qs('#ProductForm');
    if (!form || !qs('[data-pack-lines]', form)) return;
    if (form.getAttribute('data-bundle-lines-bound') === 'true') return;
    form.setAttribute('data-bundle-lines-bound', 'true');
    form.addEventListener('change', function (e) {
      if (!e.target.closest('[data-pack-lines]')) return;
      validateBundleLines(form);
    });
    var qtyInput = qs('[name="quantity"]', form);
    syncBundleLinesVisibility(qtyInput ? qtyInput.value : 1);
  }
  initPdpBundleLines();

  /* Variant picker */
  qsa('[data-bundle-option]').forEach(function (opt) {
    opt.addEventListener('click', function () {
      var group = opt.closest('[data-bundle-group]');
      qsa('[data-bundle-option]', group).forEach(function (o) {
        o.classList.toggle('is-selected', o === opt);
      });
      var id = opt.getAttribute('data-variant-id');
      var input = group && qs('[name="id"]', group.closest('form') || group);
      if (input) input.value = id;
      qsa('[data-add-to-cart]').forEach(function (add) {
        if (add.closest('[data-product-recs], .pdp-rec')) return;
        add.setAttribute('data-variant-id', id);
      });
      var available = opt.getAttribute('data-available') !== 'false';
      var price = parseInt(opt.getAttribute('data-price'), 10);
      var compare = parseInt(opt.getAttribute('data-compare'), 10) || 0;
      var formEl = group ? group.closest('form') : qs('#ProductForm');
      if (!isNaN(price) && formEl) formEl.setAttribute('data-unit-price', String(price));
      var compareEl = qs('[data-pdp-compare]');
      var saveEl = qs('[data-pdp-save]');
      if (compareEl) {
        var onSale = compare > price;
        compareEl.textContent = onSale ? formatMoney(compare) : '';
        compareEl.classList.toggle('hidden', !onSale);
        if (saveEl) {
          var pct = onSale ? Math.round(((compare - price) / compare) * 100) : 0;
          saveEl.textContent = pct ? 'Save ' + pct + '%' : '';
          saveEl.classList.toggle('hidden', !pct);
        }
      }
      updatePurchasePrices(formEl, id);
      syncStickyAtc(available);
      syncPdpTotals();
    });
  });

  function updatePurchasePrices(form, variantId) {
    if (!form) return;
    var map = parsePlanMap(form);
    if (!map) return;
    var data = map[String(variantId || (qs('[name="id"]', form) || {}).value)];
    if (!data) return;
    var select = qs('[data-selling-plan-select]', form);
    var subEl = qs('[data-sub-price]', form);
    var oneEl = qs('[data-one-time-price]', form);
    if (oneEl) oneEl.textContent = formatMoney(data.price);
    var planId = select && select.value;
    if (subEl && planId && data.plans && data.plans[planId]) {
      subEl.textContent = formatMoney(data.plans[planId].price);
    }
  }

  doc.addEventListener('change', function (e) {
    var choice = e.target.closest('[name="purchase_option"]');
    var select = e.target.closest('[data-selling-plan-select]');
    var form = e.target.closest('form');
    if (!form) return;
    if (choice || select) {
      var wrap = qs('[data-purchase-options]', form);
      var subscribe = qs('[name="purchase_option"][value="subscribe"]', form);
      var isSub = subscribe && subscribe.checked;
      qsa('[data-purchase-choice]', form).forEach(function (label) {
        label.classList.toggle(
          'is-selected',
          label.getAttribute('data-purchase-choice') === (isSub ? 'subscribe' : 'onetime')
        );
      });
      var planWrap = qs('.purchase-option__plans', form);
      var planSelect = qs('[data-selling-plan-select]', form);
      if (planWrap) planWrap.classList.toggle('is-disabled', !isSub);
      if (planSelect) planSelect.disabled = !isSub;
      updatePurchasePrices(form);
      var atc = qs('[data-pdp-atc]', form);
      syncStickyAtc(!(atc && atc.disabled));
      syncPdpTotals();
    }
  });

  /* Shopify section reload */
  function initDynamicSections(scope) {
    initPdpGalleries(scope);
    initPdpAccordions(scope);
    initStickyAtc();
    initMpv1Options();
    initDetailsClip();
    initPdpReviewBox();
    initJumpNav();
    initProductRecs(scope);
    initCollectionFilters();
  }

  doc.addEventListener('shopify:section:load', function (e) {
    initDynamicSections(e.target);
    fetchCart().then(refreshCartDrawer).catch(function () {});
  });

  /* Predictive search drawer */
  (function bindSearchDrawer() {
    var drawer = qs('[data-search-drawer]');
    if (!drawer) return;
    var input = qs('[data-search-input]', drawer);
    var popular = qs('[data-search-popular]', drawer);
    var results = qs('[data-search-results]', drawer);
    var list = qs('[data-search-list]', drawer);
    var status = qs('[data-search-status]', drawer);
    var viewAll = qs('[data-search-all]', drawer);
    var timer = null;

    function showPopular() {
      if (popular) popular.classList.remove('hidden');
      if (results) results.classList.add('hidden');
    }

    function productRow(p) {
      var img = '';
      if (p.featured_image) {
        img = typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.url || p.image || '';
      } else if (p.image) {
        img = p.image;
      }
      var price = '';
      if (p.price != null && p.price !== '') {
        var raw = Number(p.price);
        price = formatMoney(raw > 999 ? raw : Math.round(raw * 100));
      }
      var title = String(p.title || '');
      if (title.length > 56) title = title.slice(0, 53) + '…';
      var media = img
        ? '<img src="' + escapeHtml(img) + '" alt="" width="56" height="56">'
        : '<span class="search-suggest__ph" aria-hidden="true"></span>';
      return (
        '<li><a href="' +
        escapeHtml(p.url) +
        '">' +
        media +
        '<span><strong>' +
        escapeHtml(title) +
        '</strong><small>' +
        escapeHtml(price) +
        '</small></span></a></li>'
      );
    }

    function runSearch(q) {
      var term = (q || '').trim();
      if (term.length < 2) {
        showPopular();
        return;
      }
      fetch(
        '/search/suggest.json?q=' +
          encodeURIComponent(term) +
          '&resources[type]=product&resources[limit]=12&resources[options][unavailable_products]=last'
      )
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          var products =
            (data.resources && data.resources.results && data.resources.results.products) || [];
          products = products.slice(0, 8);
          if (popular) popular.classList.add('hidden');
          if (results) results.classList.remove('hidden');
          if (status) {
            status.textContent = products.length
              ? products.length + ' ' + (products.length === 1 ? 'result' : 'results')
              : 'No results found';
          }
          if (list) list.innerHTML = products.map(productRow).join('');
          if (viewAll) {
            viewAll.classList.toggle('hidden', !term);
            viewAll.href = '/search?q=' + encodeURIComponent(term) + '&type=product';
          }
        })
        .catch(function () {
          showPopular();
        });
    }

    if (input) {
      input.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          runSearch(input.value);
        }, 220);
      });
    }
  })();

  /* Sticky PDP add to cart */
  var stickyWinBound = false;
  var stickySync = null;
  function initStickyAtc() {
    var buy = qs('#ProductBuy');
    var bar = qs('[data-pdp-sticky]');
    var atc = qs('[data-pdp-atc]');
    if (!buy || !bar || !atc) return;

    function atcInView() {
      var rect = atc.getBoundingClientRect();
      var vh = window.innerHeight || doc.documentElement.clientHeight;
      return rect.top < vh - 24 && rect.bottom > 72;
    }

    function syncSticky() {
      if (atcInView()) bar.setAttribute('hidden', '');
      else bar.removeAttribute('hidden');
    }

    stickySync = syncSticky;
    syncSticky();
    if (!stickyWinBound) {
      stickyWinBound = true;
      window.addEventListener('scroll', function () { if (stickySync) stickySync(); }, { passive: true });
      window.addEventListener('resize', function () { if (stickySync) stickySync(); });
    }
    if ('IntersectionObserver' in window && atc.getAttribute('data-pdp-bound') !== 'true') {
      atc.setAttribute('data-pdp-bound', 'true');
      var observer = new IntersectionObserver(function () {
        if (stickySync) stickySync();
      }, { threshold: [0, 0.15, 0.5, 1], rootMargin: '-72px 0px -24px 0px' });
      observer.observe(atc);
    }
    syncPdpTotals();
  }
  initStickyAtc();

  function initMpv1Options() {
    var root = qs('[data-mpv1-options]');
    var form = qs('#ProductForm');
    if (!root || !form) return;
    if (root.getAttribute('data-pdp-bound') === 'true') return;
    root.setAttribute('data-pdp-bound', 'true');
    var node = qs('[data-mpv1-variants]', form);
    var variants = [];
    try {
      variants = JSON.parse((node && node.textContent) || '[]');
    } catch (err) {
      return;
    }

    function selectedOptions() {
      return qsa('.mpv1-options__row', root).map(function (row) {
        var active = qs('.mpv1-option-chip.is-active', row);
        return active ? active.getAttribute('data-option-value') : '';
      });
    }

    function applyVariant(v) {
      var idInput = qs('[name="id"]', form);
      if (idInput) idInput.value = v.id;
      form.setAttribute('data-unit-price', String(v.price));
      form.setAttribute('data-compare-price', String(v.compare || 0));
      qsa('[data-add-to-cart]').forEach(function (add) {
        if (add.closest('[data-product-recs], .pdp-rec')) return;
        add.setAttribute('data-variant-id', String(v.id));
      });
      qsa('[data-pack-total]').forEach(function (el) {
        var n = parseInt(el.getAttribute('data-pack-total'), 10) || 1;
        el.textContent = formatMoney(packOfferTotal(v.price, n, form));
      });
      qsa('[data-pack-compare]').forEach(function (el) {
        var n = parseInt(el.getAttribute('data-pack-compare'), 10) || 1;
        var wrap = el.closest('.mpv1-switcher__compare-price');
        var compare = packOfferCompare(v.compare || 0, v.price, n, form);
        if (compare) {
          el.textContent = formatMoney(compare);
          if (wrap) wrap.style.display = '';
        } else if (wrap) {
          wrap.style.display = 'none';
        }
      });
      var compareEl = qs('[data-pdp-compare]');
      var saveEl = qs('[data-pdp-save]');
      var onSale = v.compare > v.price;
      var pct = onSale ? Math.round(((v.compare - v.price) / v.compare) * 100) : 0;
      if (compareEl) {
        compareEl.textContent = onSale ? formatMoney(v.compare) : '';
        compareEl.classList.toggle('hidden', !onSale);
      }
      if (saveEl) {
        saveEl.textContent = pct ? 'Save ' + pct + '%' : '';
        saveEl.classList.toggle('hidden', !pct);
      }
      var badge = qs('[data-pdp-sale-badge]');
      if (badge) {
        badge.textContent = pct ? '−' + pct + '%' : '';
        badge.classList.toggle('hidden', !pct);
      }
      var skuEl = qs('[data-pdp-sku]');
      var skuRow = qs('[data-pdp-sku-row]');
      if (skuEl) skuEl.textContent = v.sku || '';
      if (skuRow) skuRow.classList.toggle('hidden', !v.sku);
      var main = qs('[data-pdp-main-img], .mpv1-gallery__main-img');
      if (v.image && main) {
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = v.image;
      }
      if (v.url && window.history && window.history.replaceState) {
        window.history.replaceState({}, '', v.url);
      }
      updatePurchasePrices(form, v.id);
      syncStickyAtc(v.available);
      syncPdpTotals();
      seedBundleLinesFromChips(form);
      validateBundleLines(form);
    }

    root.addEventListener('click', function (e) {
      var chip = e.target.closest('.mpv1-option-chip');
      if (!chip) return;
      e.preventDefault();
      var row = chip.closest('.mpv1-options__row');
      qsa('.mpv1-option-chip', row).forEach(function (c) {
        c.classList.toggle('is-active', c === chip);
      });
      var picked = qs('[data-option-picked]', row);
      if (picked) picked.textContent = chip.getAttribute('data-option-value') || chip.getAttribute('title') || '';
      var opts = selectedOptions();
      var match = variants.filter(function (v) {
        return opts.every(function (opt, i) {
          return v.options[i] === opt;
        });
      })[0];
      if (match) applyVariant(match);
      else syncStickyAtc(false);
    });
  }
  initMpv1Options();

  doc.addEventListener('click', function (e) {
    var pack = e.target.closest('[data-pdp-pack]');
    if (pack) {
      if (e.target.closest('[data-pack-lines]')) return;
      var n = parseInt(pack.getAttribute('data-pdp-pack'), 10) || 1;
      var input = qs('#ProductForm [name="quantity"]');
      if (input) input.value = n;
      var radio = qs('input[type="radio"]', pack);
      if (radio) radio.checked = true;
      syncPdpTotals();
      syncBundleLinesVisibility(n);
      return;
    }

    var both = e.target.closest('[data-add-both]');
    if (both) {
      e.preventDefault();
      var idA = Number(both.getAttribute('data-id-a'));
      var idB = Number(both.getAttribute('data-id-b'));
      if (!idA || !idB) return;
      both.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: idA, quantity: 1 }, { id: idB, quantity: 1 }] }),
      })
        .then(function (r) {
          if (!r.ok) throw r;
          return fetchCart();
        })
        .then(function (cart) {
          refreshCartDrawer(cart);
          openDrawer('#CartDrawer');
        })
        .catch(function () {
          window.location.href = '/cart';
        })
        .finally(function () {
          both.classList.remove('is-loading');
        });
    }
  });

  doc.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('#ProductForm [name="quantity"]')) syncPdpTotals();
  });

  function initDetailsClip(scope) {
    qsa('[data-pdp-desc]', scope || doc).forEach(function (section) {
      if (section.getAttribute('data-pdp-bound') === 'true') return;
      var clip = qs('[data-pdp-clip]', section);
      var btn = qs('[data-pdp-clip-toggle]', section);
      if (!clip || !btn) return;
      section.setAttribute('data-pdp-bound', 'true');

      function needsClip() {
        return clip.scrollHeight > clip.clientHeight + 24;
      }

      function bindToggle() {
        btn.addEventListener('click', function () {
          var open = clip.classList.toggle('is-open');
          var label = qs('[data-pdp-clip-label]', btn) || btn;
          label.textContent = open
            ? btn.getAttribute('data-hide') || 'Show less'
            : btn.getAttribute('data-show') || 'Show full details';
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          btn.classList.toggle('is-open', open);
          if (!open) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      // Hidden responsive copy can't measure height reliably.
      if (getComputedStyle(section).display === 'none') {
        bindToggle();
        return;
      }

      if (!needsClip()) {
        clip.classList.add('is-open');
        btn.hidden = true;
        return;
      }

      bindToggle();
    });
  }
  initDetailsClip();

  function initSizeChart() {
    var chart = qs('[data-size-chart]');
    if (!chart || chart.getAttribute('data-pdp-bound') === 'true') return;
    chart.setAttribute('data-pdp-bound', 'true');

    function openChart(trigger) {
      chart.removeAttribute('hidden');
      doc.body.classList.add('mpv1-size-chart-open');
      chart._sizeChartTrigger = trigger || null;
      var closeBtn = qs('[data-size-chart-close].mpv1-size-chart__close', chart) || qs('[data-size-chart-close]', chart);
      if (closeBtn) closeBtn.focus();
    }

    function closeChart() {
      chart.setAttribute('hidden', '');
      doc.body.classList.remove('mpv1-size-chart-open');
      if (chart._sizeChartTrigger) chart._sizeChartTrigger.focus();
    }

    doc.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-size-chart-open]');
      if (openBtn) {
        e.preventDefault();
        openChart(openBtn);
        return;
      }
      if (e.target.closest('[data-size-chart-close]')) {
        e.preventDefault();
        closeChart();
      }
    });
  }
  initSizeChart();

  function initPdpReviewBox() {
    var root = qs('.pdp-split__reviews');
    if (!root || root.getAttribute('data-pdp-bound') === 'true') return;
    root.setAttribute('data-pdp-bound', 'true');

    function compact() {
      var host =
        qs('.AirReviews-Widget--Block, .AirReviews-Embed-BlockWrapper, .AirReviews-BlockWrapper, #AirReviews-BlockWrapper', root) ||
        qs('.AirReviews-Widget--Block', root);
      if (!host) return;
      host.classList.add('pdp-air-host');
      var nodes = qsa('div, ul, section', host);
      var best = null;
      var bestCount = 0;
      nodes.forEach(function (el) {
        if (el === host || el.children.length < 3) return;
        if (el.children.length > bestCount) {
          best = el;
          bestCount = el.children.length;
        }
      });
      if (best) best.classList.add('pdp-air-list');
    }

    compact();
    if (typeof MutationObserver === 'undefined') return;
    var mo = new MutationObserver(function () {
      compact();
    });
    mo.observe(root, { childList: true, subtree: true });
    setTimeout(compact, 1200);
    setTimeout(compact, 3200);
  }
  initPdpReviewBox();

  function initJumpNav() {
    var nav = qs('[data-pdp-jump]');
    if (!nav || !('IntersectionObserver' in window)) return;
    if (nav.getAttribute('data-pdp-bound') === 'true') return;
    nav.setAttribute('data-pdp-bound', 'true');
    var links = qsa('a', nav);
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          links.forEach(function (a) {
            a.classList.toggle('is-active', a.getAttribute('href') === '#' + entry.target.id);
          });
        });
      },
      { rootMargin: '-40% 0px -50% 0px', threshold: 0.1 }
    );
    ['ProductOverview', 'ProductDetails', 'ProductReviews', 'ProductPair', 'ProductFaq'].forEach(function (id) {
      var el = doc.getElementById(id);
      if (el) observer.observe(el);
    });
  }
  initJumpNav();

  /* Product recommendations section reload */
  function initProductRecs(scope) {
    qsa('[data-product-recs]', scope || doc).forEach(function (root) {
      if (root.getAttribute('data-pdp-bound') === 'true') return;
      root.setAttribute('data-pdp-bound', 'true');
      var url = root.getAttribute('data-url');
      if (!url) return;
      fetch(url)
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var docEl = new DOMParser().parseFromString(html, 'text/html');
          var next = docEl.querySelector('[data-product-recs]');
          var hasItems = function (el) {
            return el && el.querySelector('.pdp-rec, .pr-item__product, .pdp-fbt');
          };
          if (next && hasItems(next)) root.innerHTML = next.innerHTML;
          else if (!hasItems(root)) root.style.display = 'none';
        })
        .catch(function () {
          if (!root.querySelector('.pdp-rec, .pr-item__product, .pdp-fbt')) root.style.display = 'none';
        });
    });
  }
  initProductRecs();

  (function bindQuickView() {
    var modal = qs('[data-quick-view-modal]');
    if (!modal) return;
    var titleEl = qs('[data-qv-title]', modal);
    var priceEl = qs('[data-qv-price]', modal);
    var compareEl = qs('[data-qv-compare]', modal);
    var imageEl = qs('[data-qv-image]', modal);
    var optionsEl = qs('[data-qv-options]', modal);
    var stockEl = qs('[data-qv-stock]', modal);
    var linkEl = qs('[data-qv-link]', modal);
    var atcBtn = qs('[data-qv-atc]', modal);
    var qtyEl = qs('[data-qv-qty]', modal);
    var starsEl = qs('[data-qv-stars]', modal);
    var productData = null;
    var selected = {};

    function optionLabel(name) {
      var n = String(name || '').toLowerCase();
      if (n === 'leather' || n === 'material') return 'Formula';
      if (n === 'stay') return 'Size';
      return name;
    }

    function escapeHtml(str) {
      return String(str || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function mountQvStars(openBtn) {
      if (!starsEl) return;
      starsEl.innerHTML = '';
      if (!openBtn) return;
      var root = openBtn.closest('.product-card, .vh__featured, .cart-upsell, article');
      var widget = root && root.querySelector('.AirReviews-Widget--Stars');
      if (!widget) return;
      starsEl.appendChild(widget.cloneNode(true));
    }

    function closeQuickView() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      modal.hidden = true;
      lockScroll(false);
      restoreFocus();
      productData = null;
    }

    function openQuickView() {
      lastFocus = doc.activeElement;
      modal.hidden = false;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      var closeBtn = qs('[data-close-quick-view]', modal);
      if (closeBtn) {
        setTimeout(function () {
          closeBtn.focus();
        }, 60);
      }
    }

    function findVariant() {
      if (!productData || !productData.variants) return null;
      return (
        productData.variants.find(function (v) {
          return productData.options.every(function (opt, i) {
            return v['option' + (i + 1)] === selected[opt.name];
          });
        }) || productData.variants[0]
      );
    }

    function syncUI() {
      var variant = findVariant();
      if (!variant) return;
      if (atcBtn) {
        atcBtn.setAttribute('data-variant-id', String(variant.id));
        atcBtn.disabled = !variant.available;
        atcBtn.textContent = variant.available
          ? atcBtn.getAttribute('data-label-atc') || 'Add to Cart'
          : atcBtn.getAttribute('data-label-sold') || 'Sold out';
      }
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        compareEl.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
        compareEl.classList.toggle('hidden', !onSale);
      }
      if (stockEl) {
        stockEl.textContent = variant.available ? 'In stock · Discreet dispatch' : 'Sold out';
        stockEl.classList.toggle('is-soldout', !variant.available);
      }
      if (imageEl) {
        var img =
          (variant.featured_image && (variant.featured_image.src || variant.featured_image)) ||
          productData.featured_image ||
          (productData.images && productData.images[0]);
        if (img) {
          var src = typeof img === 'string' ? img : img.src || '';
          if (src.indexOf('//') === 0) src = 'https:' + src;
          imageEl.src = src.replace(/(\.[a-z]+)(\?|$)/i, '_640x$1$2');
          imageEl.alt = productData.title || '';
        }
      }
      qsa('[data-qv-option-value]', optionsEl).forEach(function (btn) {
        var name = btn.getAttribute('data-option-name');
        var value = btn.getAttribute('data-option-value');
        btn.classList.toggle('is-active', selected[name] === value);
        var possible = productData.variants.some(function (v) {
          var match = true;
          productData.options.forEach(function (opt, i) {
            var key = 'option' + (i + 1);
            if (opt.name === name) {
              if (v[key] !== value) match = false;
            } else if (selected[opt.name] && v[key] !== selected[opt.name]) {
              match = false;
            }
          });
          return match && v.available;
        });
        btn.classList.toggle('is-unavailable', !possible);
      });
    }

    function normalizeOptions(data) {
      if (!data.options || !data.options.length) return [];
      if (typeof data.options[0] === 'string') {
        return data.options.map(function (name, i) {
          var values = [];
          (data.variants || []).forEach(function (v) {
            var val = v['option' + (i + 1)];
            if (val && values.indexOf(val) === -1) values.push(val);
          });
          return { name: name, values: values };
        });
      }
      return data.options.map(function (opt) {
        return {
          name: opt.name || opt,
          values: opt.values || [],
        };
      });
    }

    function renderProduct(data) {
      productData = data;
      data.options = normalizeOptions(data);
      selected = {};
      if (titleEl) titleEl.textContent = data.title || '';
      if (linkEl) linkEl.href = '/products/' + data.handle;
      if (qtyEl) qtyEl.value = '1';
      if (atcBtn) {
        atcBtn.setAttribute('data-label-atc', atcBtn.textContent.trim() || 'Add to Cart');
        atcBtn.setAttribute('data-label-sold', 'Sold out');
      }
      if (optionsEl) {
        optionsEl.innerHTML = '';
        var hasOnlyDefault =
          data.variants.length === 1 &&
          (!data.options.length || (data.options[0] && data.options[0].name === 'Title'));
        if (!hasOnlyDefault && data.options && data.options.length) {
          data.options.forEach(function (opt) {
            selected[opt.name] = opt.values[0];
            var group = doc.createElement('div');
            group.className = 'qv__option';
            group.innerHTML = '<p class="qv__option-label">' + escapeHtml(optionLabel(opt.name)) + '</p>';
            var chips = doc.createElement('div');
            chips.className = 'qv__chips';
            opt.values.forEach(function (val) {
              var btn = doc.createElement('button');
              btn.type = 'button';
              btn.className = 'qv__chip';
              btn.textContent = val;
              btn.setAttribute('data-qv-option-value', '');
              btn.setAttribute('data-option-name', opt.name);
              btn.setAttribute('data-option-value', val);
              chips.appendChild(btn);
            });
            group.appendChild(chips);
            optionsEl.appendChild(group);
          });
          var firstAvail = data.variants.find(function (v) {
            return v.available;
          });
          if (firstAvail) {
            data.options.forEach(function (opt, i) {
              selected[opt.name] = firstAvail['option' + (i + 1)];
            });
          }
        }
      }
      syncUI();
      openQuickView();
    }

    function loadProduct(handle, openBtn) {
      if (!handle) return;
      modal.classList.add('is-loading');
      fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) {
          if (!r.ok) throw r;
          return r.json();
        })
        .then(function (data) {
          renderProduct(data);
          mountQvStars(openBtn);
        })
        .catch(function () {
          window.location.href = '/products/' + handle;
        })
        .finally(function () {
          modal.classList.remove('is-loading');
        });
    }

    doc.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-quick-view]');
      if (openBtn) {
        e.preventDefault();
        e.stopPropagation();
        loadProduct(openBtn.getAttribute('data-handle'), openBtn);
        return;
      }
      if (e.target.closest('[data-close-quick-view]')) {
        e.preventDefault();
        closeQuickView();
        return;
      }
      var chip = e.target.closest('[data-qv-option-value]');
      if (chip && optionsEl && optionsEl.contains(chip)) {
        e.preventDefault();
        selected[chip.getAttribute('data-option-name')] = chip.getAttribute('data-option-value');
        syncUI();
      }
    });

    doc.addEventListener('kneevive:close-quick-view', closeQuickView);
  })();

  var filtersWinBound = false;
  function initCollectionFilters() {
    var root = qs('[data-collection-filters]');
    if (!root) return;
    if (root.getAttribute('data-pdp-bound') === 'true') return;
    root.setAttribute('data-pdp-bound', 'true');
    var panel = qs('[data-cf-panel]', root);
    var backdrop = qs('.cf__backdrop', root);
    var form = qs('[data-cf-form]', root);
    var sortSelect = qs('[data-cf-sort]', root);
    var sortInput = qs('[data-cf-sort-input]', root);

    function openFilters() {
      if (!panel) return;
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      if (backdrop) backdrop.hidden = false;
      lockScroll(true);
    }

    function closeFilters() {
      if (!panel) return;
      panel.classList.remove('is-open');
      if (window.matchMedia('(max-width: 900px)').matches) {
        panel.setAttribute('aria-hidden', 'true');
      } else {
        panel.removeAttribute('aria-hidden');
      }
      if (backdrop) backdrop.hidden = true;
      lockScroll(false);
    }

    function syncPanelA11y() {
      if (!panel) return;
      if (window.matchMedia('(max-width: 900px)').matches) {
        if (!panel.classList.contains('is-open')) panel.setAttribute('aria-hidden', 'true');
      } else {
        panel.removeAttribute('aria-hidden');
        panel.classList.remove('is-open');
        if (backdrop) backdrop.hidden = true;
        lockScroll(false);
      }
    }

    syncPanelA11y();
    if (!filtersWinBound) {
      filtersWinBound = true;
      window.addEventListener('resize', function () {
        var live = qs('[data-collection-filters]');
        if (!live) return;
        var livePanel = qs('[data-cf-panel]', live);
        var liveBackdrop = qs('.cf__backdrop', live);
        if (!livePanel) return;
        if (window.matchMedia('(max-width: 900px)').matches) {
          if (!livePanel.classList.contains('is-open')) livePanel.setAttribute('aria-hidden', 'true');
        } else {
          livePanel.removeAttribute('aria-hidden');
          livePanel.classList.remove('is-open');
          if (liveBackdrop) liveBackdrop.hidden = true;
          lockScroll(false);
        }
      });
    }

    doc.addEventListener('click', function (e) {
      if (e.target.closest('[data-cf-open]')) {
        e.preventDefault();
        openFilters();
        return;
      }
      if (e.target.closest('[data-cf-close]')) {
        e.preventDefault();
        closeFilters();
      }
    });

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.href = url.toString();
      });
    }

    if (form) {
      form.addEventListener('change', function (e) {
        if (!e.target.matches('input[type="checkbox"]')) return;
        if (window.matchMedia('(min-width: 901px)').matches) form.submit();
      });
      if (sortInput && sortSelect) {
        form.addEventListener('submit', function () {
          sortInput.value = sortSelect.value;
        });
      }
    }
  }
  initCollectionFilters();
})();
